import React from 'react';
import '../App.css';
import { API_URL } from '../Config';

function FramePreviewModal({ isOpen, onClose, item }) {
  if (!isOpen || !item) return null;

  return (
    <div className="modal-overlay">
      <div className="modal-content frame-preview-modal">
        <h2>Annotated Frame Preview</h2>
        
        <div className="frame-info-section">
          <p><strong>Frame Type:</strong> {item.type}</p>
          {item.timestamp && (
            <p><strong>Timestamp:</strong> {Number.isFinite(item.timestamp) ? item.timestamp.toFixed(2) : '0.00'}s</p>
          )}
          {item.startTime && item.endTime && (
            <p><strong>Duration:</strong> {Number.isFinite(item.startTime) ? item.startTime.toFixed(2) : '0.00'}s - {Number.isFinite(item.endTime) ? item.endTime.toFixed(2) : '0.00'}s</p>
          )}
        </div>

        <div className="frame-image-container">
          {item.annotated_image_path ? (
            <img 
              src={`${API_URL}${item.annotated_image_path}`} 
              alt="Annotated Frame" 
              className="frame-preview-image"
            />
          ) : (
            <div className="no-annotation-message">
              <p>No annotated frame available</p>
            </div>
          )}
        </div>

        <div className="modal-actions">
          <button onClick={onClose} className="modal-cancel-button">Close</button>
        </div>
      </div>
    </div>
  );
}

export default FramePreviewModal;